import { render, staticRenderFns } from "./update-produit-modal.vue?vue&type=template&id=1ea7a8f0&scoped=true"
import script from "./update-produit-modal.vue?vue&type=script&lang=js"
export * from "./update-produit-modal.vue?vue&type=script&lang=js"
import style0 from "./update-produit-modal.vue?vue&type=style&index=0&id=1ea7a8f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea7a8f0",
  null
  
)

export default component.exports